import React, { Component } from 'react';
//import PresentationSingleRecording from 'pages/PKCreation/PresentationSingleRecording/Presentation';
//import PresentationRecordingPerSlide from 'pages/PKCreation/PresentationRecordingPerSlide/Presentation';
import {  user_access_level, user_account_level } from 'Api/Api';
// user_access_token,
// import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import axios from 'axios';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import {  withRouter, Link } from 'react-router-dom';
// Redirect,
import sanitize from 'sanitize-filename';

// Links of Description section
import "../style.css";
import {  user_entity_uuid } from "Api/Api";
// Category_list_Api, HeaderConfig, user_API,
import { apiUrl, org_friendly_url, presentation_Creation_API, myHeaders_Autorized, myHeaders_Auth_With_Cache_Control } from 'Api/Api'
import {  current_unix_stamp, get_current_unix_stamp } from "utils/Helper";
// massageFriendlyUrl, saveKey,
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
// import MultiSelect from "components/MultiSelectSearch/MultiSelect";

// import Multisearch from "components/MultiSelectSearch/MultiSearch";
//import Button from 'components/Button/Button';
import { slides_Creation_API } from 'Api/Api';
import logo from "Assets/cloud-upload.png";
import RUG from "react-upload-gallery";
import "react-upload-gallery/dist/style.css";
// Links of Audio
// import mic from "Assets/mic.png";
// import cloud from "Assets/cloud-upload.png";
import option from "Assets/Group 13.png";
// import option1 from "Assets/option1.png";
// Links of Presentation section
// import { user_Status_Ver,user_Status } from 'Api/Api'
// Links of PK success page
//import PKSuccess from 'pages/PKList/PkList';
// import LegacyJSON from 'utils/LegacyArrays.json';
import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

let event_Name_Arr= [];
let my_Events = [];
let pkEvent = [];
// let event_Picked;
//let slideImgPresentation=[];
let apiEventResArr=[]; // for event data from API
//let SlideTempArr = [];
//let SlideFinalPushTemp = [];
//let SlideArrData = []; // will hold slides from database
//let SlideDataPatch = [];
//let SlideImageArr = [];
//let SlideImageThumbnail = [];
//let slideCoverArr=[]; // for the actual dropdown data
//let promiseCheck=[];

class PresentationSlides extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props)
        this.state = {
          pptx_to_slides_running_message: '',
            custom_cover_image: false,
            pptx_data_array_buffer: null,
            pptx_to_slides_file: '',
            slide_problem_message: '',
            slide_upload_progress_message: '',
            slideCoverArr: [],
            slide_count: 20,
            presentation_uuid: props.presentation_uuid,
            touched: {},
            //isCreate: false,
            uploadedFileContents:[],
            pkOwnerCheck:true,
            // Tabs Code states
            step: 1,
            textarea: '',
            textareaError: '',
            //PKTitle: '',
            //FriendlyUrl: '',
            eventdropdown: '',
            // Description Links starts
            descriptionLoader: false,
            myEventsState: [],
            PKCreationPresentationId: null,
            pkFriendlyUrl: '',
            pkDescription: '',
            // pkEvent: '',
            pkEvent_name:'',
            myEventsDefault:'None',
            validated: false,
            showComponent: false,
            Categories: [],
            Category_names: [],
            loading: true,
            FriendlyUrlStatus: 0,
            cat_Arr: null,
            friendlyUrlCollision: true,
            pkTitleCollision: true,
            friendlyurl_title: '',
            apiCategoryRes:[],
            //apiCategories:[],
            apiEvents:[],
            btnDisableValidate:true,
             //Image section states
            //SlideImageCover:0,
            //slideCoverNum:0, // updated cover image index
            //slideBG: "black", // updated pad_color
            slide_cover_index_changed: false,
            slide_cover_index: 0, // starting cover image index (order_integer - 1)
            pad_color: 'black', // starting pad_color
            pad_color_changed: false,
            ImageUploadLoader: false,
            images: [],
            SlideNumber: 0,
            FriendlyUrlNumber: 1,
            //SlideCounter: 0,
            presentationId: '',
            savedImages: [], // on edit, this is the slides from the database before changes are done
            //apiImagesStack:[],
            imageValidator: false,
            ImgPublishBtn:false,
            // Audio section starts
            audioType: "upload",   
            pkAudio:'',
            stored_Cat:[], 
            // createPkStatus:false
            allowed: true,
            audio_delay:0,
            language_abbreviation:'en-US',
            audioFileName:'',
            rugChangedCount: 0,
            slidesChanged: false
        };
        this.default_slide_length = 20;
        this.default_slide_count = 20;
        //this.number_of_slides = 20;
        
        this.max_slide_size_bytes = 10000000; // 10MB

        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        
        this.check_pptx_to_slides_interval = null;
        
        //this.uploadPptxFileRef = React.createRef();
    }

    // Images section starts
    // API Calls to create PK
    createPk = () => {
        this.PKCreateImage()
    };

    // Create Pk starts here
    PKCreateImage = async () => {
        console.log("PKCreateImage",this.state.images.length);
        
        if (this.state.images.length !== this.state.slide_count) {
            this.setState({ ImageUploadLoader: false, imageValidator: true })
            return;
        }
        
        this.setState({ slide_problem_message: '', ImageUploadLoader: true, imageValidator: false });
        
        // figure out which are already in database and which are new
        let mutated_images = [...this.state.images];
        //let mutated_fileContents = [...this.state.fileContents];
        let fileContents = [];
        
        let got_data_promises = [];
        
        for (let i = 0; i < this.state.images.length; i++) {
            let image_obj = this.state.images[i];
            if (!image_obj.file) {
                continue;
            }
            
            // newly uploaded
            console.log("Getting local slide data from spot #",i);
            // Create a new XMLHttpRequest object
            let got_data_promise = new Promise(function (resolve, reject) {
                let xhr = new XMLHttpRequest();
                xhr.open('GET', image_obj['source'], true);
                xhr.responseType = "arraybuffer";
                //var self = this;
                // This will be called after the response is received from xhr.send()
                xhr.onload = function () {
                    let arrayBufferView = new Uint8Array(this.response);
                    fileContents[i] = arrayBufferView;
                    resolve();
                };
                xhr.send();
            });
            got_data_promises.push(got_data_promise);
        }
        await Promise.all(got_data_promises);
        console.log("Got all local slide data");
        
        // make sure none of the slides are over our max slide size (bytes)
        for (let i = 0; i < fileContents.length; i++) {
            if (fileContents[i] && fileContents[i].byteLength > this.max_slide_size_bytes) {
                this.setState({
                    slide_problem_message: 'Slide '+(i+1)+' filesize is too large ('+fileContents[i].byteLength+' bytes) - please limit slide filesize to < '+this.max_slide_size_bytes+' bytes'
                });
                return;
            }
        }
        
        // now see if we need to create new slides in the database - do all the new slide POSTs in parallel
        console.log("Creating slides in database");
        this.setState({
            slide_upload_progress_message: 'Preparing'
        });
        let slide_create_promises = [];
        for (let i = 0; i < this.state.images.length; i++) {
            let image_obj = this.state.images[i];
            if (!image_obj.file || fileContents[i] === null) {
                // this is ok - just means the image was remote (already in database)
                continue;
            }
            let slide_name = `${this.state.pkTitle}-slide ${i+1}-${current_unix_stamp}`;
            let slide_friendly_url = `${this.state.pkTitle}-slide_${i+1}-${current_unix_stamp}`;
            slide_friendly_url = slide_friendly_url.toLowerCase().replace(/[\s.,&]/g, "-");
            slide_friendly_url = sanitize(slide_friendly_url);
            let slide_info = {
                entity_name: slide_name,
                friendly_url: slide_friendly_url
            }
            // JBB 4/23/2021 - to avoid a race condition where a presentation owner was added after this page was loaded, re-grab owners
            let params = {
              attributes: ['shared_access_write_uuids']
            };
            let presentation_info = await axios.get(`${presentation_Creation_API}/${this.state.presentation_uuid}`, { params, ...myHeaders_Auth_With_Cache_Control });
            
            if (presentation_info.data.shared_access_write_uuids && presentation_info.data.shared_access_write_uuids.length > 1) {
                let tmp_additional_owners_array = [];
                for (let additional_owner_uuid of presentation_info.data.shared_access_write_uuids) {
                    if (additional_owner_uuid === user_entity_uuid) {
                        tmp_additional_owners_array.push({
                            entity_uuid: additional_owner_uuid,
                            xref_data: {
                                entity_owner_integer: 1
                            }
                        });
                    } else {
                        tmp_additional_owners_array.push({
                            entity_uuid: additional_owner_uuid,
                            xref_data: {
                                entity_owner_integer: 2
                            }
                        });
                    }
                }
                if (tmp_additional_owners_array.length > 0) {
                    slide_info.users = tmp_additional_owners_array;
                }
            }
            console.log("Creating database slide in spot #",i);
            slide_create_promises.push(this.createSlide(slide_info,i));
        }
        console.log("Waiting for database slide creation to complete");
        let new_slide_data = await Promise.all(slide_create_promises);

        // put new slide uuids into images array
        for (let new_slide_obj of new_slide_data) {
            mutated_images[new_slide_obj.index].entity_uuid = new_slide_obj.entity_uuid;
        }
        
        // now do getSignedUrl / PUT upload one by one so we can show progress
        for (let i = 0; i < this.state.images.length; i++) {
            let image_obj = this.state.images[i];
            image_obj.index = i;
            if (!image_obj.file || fileContents[i] === null) {
                // this is ok - just means the image was remote (already in database)
                continue;
            }        

            this.setState({
                slide_upload_progress_message: 'Slide '+(i+1)+': Uploaded 0%'
            });
            
            // call getSignedUrl
            let new_slide_obj = await this.prepareUploadSlide(image_obj, mutated_images[i].entity_uuid);
            mutated_images[i].upload_info = new_slide_obj;

            if (!image_obj.upload_info) {
                console.error("Missing data for PUT signed URL");
                continue;
            }
            
            // upload slide data using PUT to signed URL
            let slide_length_bytes = fileContents[i].byteLength;
            let config = {
                headers: { "Content-Type": image_obj.upload_info.content_type },
                onUploadProgress: (progressEvent) => {
                  let upload_percent = Math.floor(progressEvent.loaded / slide_length_bytes * 100);
                  //console.log("SLIDE UPLOADING PROGRESS ("+i+")",progressEvent.loaded,upload_percent);
                  this.setState({
                    slide_upload_progress_message: 'Slide '+(i+1)+': Uploaded '+upload_percent+'%'
                  });
                }
            };
            
            await axios.put(image_obj.upload_info.upload_url, fileContents[i], config);
            
        }

        // JBB - 4/21/2021 - confirm that all the slide uploaded!
        this.setState({
          slide_upload_progress_message: 'Confirming Slide Upload'
        });
        let img_check_promises = [];
        mutated_images.forEach (( img_obj ) => {
          //console.log("CHECKING IMAGE",img_obj);
          let img_source_to_check = '';
          if (img_obj.upload_info && img_obj.upload_info.asset_url) {
            img_source_to_check = img_obj.upload_info.asset_url;
          } else {
            img_source_to_check = img_obj['source'];
          }
          img_check_promises.push(this.imageExists(img_source_to_check));
        });
        let img_check_results = await Promise.all(img_check_promises);
        if (img_check_results.includes(false)) {
          // we had an error! abort!
          this.setState({ slide_upload_progress_message: '', ImageUploadLoader: false, slide_problem_message: 'ERROR uploading one ore more slides - please trying re-adding images and saving again' });
          return;          
        }
        
        await this.updatePresentationPatch(mutated_images);
        this.props.history.push(`${this.workspace_base_url}${local_routes.pkcreation}/${this.state.presentation_uuid}/audio`);
    };
    
    
    imageExists = async (src) => {
      return new Promise( function(resolve, reject) {
        let img = new window.Image();
        img.src = src;
  
        img.onload = function () {
          console.log("TEST IMG onload",img.width,img.height);
          resolve(true);
        };
        img.onerror = function () {
          console.log("TEST IMG onerror",img.width,img.height);
          resolve(false);
        };
      });
    }
    

    createSlide = async (SlidesNameData,index) => {
        // creates new slide in database - returns new slide uuid
        let post_response = await axios.post(
            slides_Creation_API,
            JSON.stringify(SlidesNameData),
            myHeaders_Autorized
        );
        if (!post_response.data.entity_uuid) {
            console.error("createSlide Error - POST new slide did not return an entity_uuid");
            return false;
        }

        return {entity_uuid:post_response.data.entity_uuid,index};
    }

    // call getSignedUrl and get a signed URL for each slide, to be used in a PUT request
    prepareUploadSlide = async (ImageData,slide_uuid) => {
        // creates new

        // let imgNameExt;

        /*
        ImageData.name = ImageData.name.toLowerCase();
        // this code wrecks things for things like .JPG (caps)
        
        if(ImageData.name.includes('.jpg') || ImageData.name.includes('.png') || ImageData.name.includes('.gif') || ImageData.name.includes('.jpeg')) {
            // uploaded
            imgNameExt=ImageData.name
        } else {
            // from PK system, from edit
            let tmp_str = ImageData.source;
            let tmp_array = tmp_str.split('/');
            imgNameExt = tmp_array[tmp_array.length-1];
        }
        

        let imgNameExtConv=imgNameExt.replace(/[(,),',",\s]+/g, "");
        // slides_Creation_API for signed URL
        */
        
        let extension = ImageData.name.split('.').pop();
        
        let params = {
            asset_type: 'image',
            filename: 'slide_'+(ImageData.index+1)+'_'+(new Date().getTime())+'.'+extension
            //filename: sanitize(ImageData.name).replace(/[&\s]/g, '_').toLowerCase()
        }
        
        let gsu_response = await axios.post(`${slides_Creation_API}/${slide_uuid}/getUploadSignedUrl`,{},{ params, ...myHeaders_Autorized});

        return gsu_response.data;
    }

    updatePresentationPatch = async (images) => {
        // First test if there were changes
        let changes_made = false;
        if (this.state.rugChangedCount > 1) {
            // slides got changed - re-ordering, etc.
            changes_made = true;
        }
        if (this.state.pad_color_changed) {
            // background color was changed
            changes_made = true;
        }
        if (this.state.slide_cover_index_changed) {
            // cover image changed
            changes_made = true;
        }
        
        console.log("updatePresentationPatch",this.state.rugChangedCount,this.state.pad_color,this.state.pad_color_changed,this.state.slide_cover_index,this.state.slide_cover_index_changed,changes_made);
        if (!changes_made) {
            //console.log("RESET rugChangedCount");
            this.setState({ rugChangedCount: 0 });
            return;
        } else {
            //this.setState({ rugChangedCount: 0, slidesChanged: true });
            this.setState({ slidesChanged: true, rugChangedCount: 0, slide_cover_index_changed: false, pad_color_changed: false }); // to help decide later if we need to create new video
        }
        
        // we need to remove the old slides xrefs
        let old_slide_response = await axios.get(`${presentation_Creation_API}/${this.state.PKCreationPresentationId}/slides?attributes_array=${encodeURIComponent('["entity_uuid"]')}`, myHeaders_Auth_With_Cache_Control);
        let delete_slide_xref_promises = [];
        for (let old_slide_obj of old_slide_response.data) {
            delete_slide_xref_promises.push(axios.delete(`${presentation_Creation_API}/${this.state.PKCreationPresentationId}/slides/${old_slide_obj.entity_uuid}`, myHeaders_Autorized, {}))
        }
        await Promise.all(delete_slide_xref_promises);
        
        let slides_xref_obj_array = [];
        for (let i = 0; i < images.length; i++) {
            let slide_xref_obj = {
                entity_uuid: images[i].entity_uuid,
                xref_data: {
                    order_integer: i+1
                }
            }
            slides_xref_obj_array.push(slide_xref_obj);
        }
        
        //SlideDataPatch.length = 0;
        //SlideArrData.forEach(function (item,count) {
        //    SlideDataPatch.push({ "xref_data": { "order_integer": count+1 }, "entity_uuid": item.uuid })
        //})
        
        //let cover_image_url = SlideImageArr[this.state.slideCoverNum];
        
         // this cover image logic is weird - changing
        /*
        SlideImageArr.forEach((item, index) => {
            if (index === parseInt(slideCoverNum)) {
                SlideImageThumbnail.push(item)
            }
        })
        */
        let PatchImageInPresentation = {
            "slides": slides_xref_obj_array,
            //"pad_color": this.state.slideBG,
            "pad_color": this.state.pad_color,
            //"image_url": cover_image_url,
            "trigger_create_presentation_slides_zip": true,
            "trigger_create_presentation_pptx": true,
            current_slide_count: slides_xref_obj_array.length // this is just to have an indicator on My PKs if we have all our slides
        };

        if (this.state.slide_cover_index !== 'custom' && images[this.state.slide_cover_index]) {
          let cover_image_obj = images[this.state.slide_cover_index];
          let cover_image_url = "";
          if (cover_image_obj.upload_info) {
              cover_image_url = cover_image_obj.upload_info.asset_url;
          } else {
              cover_image_url = cover_image_obj['source'];
              // remove the subprocesses from url
              let remove_string = "pad"+this.state.pad_color+"_noborder_480x270/";
              cover_image_url = cover_image_url.replace(remove_string,"");
          }
          PatchImageInPresentation.image_url = cover_image_url;
        }
        
        //console.log("UPDATING PRESENTATION",JSON.stringify(PatchImageInPresentation,null,2));
        console.log("Updating presentation slides xref and related slide information");
        
        // API Patch slide info
        await axios.patch(`${presentation_Creation_API}/${this.state.PKCreationPresentationId}`, PatchImageInPresentation, myHeaders_Autorized);
    }

    // Create Pk Ends here

    onChangeImages = (images) => {
        //console.log("onChangeImages",this.state.rugChangedCount,JSON.stringify(images,null,2));
        this.setState({ rugChangedCount: this.state.rugChangedCount + 1 });
        this.setState({ ImageUploadLoader: false, imageValidator: false });
        if (this.state.images.some(item => item.file)) {
           this.setState({ImgPublishBtn:true})
        } 
        if (images.length > this.state.slide_count) {
            images.length = this.state.slide_count;
            // let checkLen = images.length - 20;
            // images.splice(-checkLen, checkLen);
            this.setState({ images: images })
            //this.setState({ SlideImageCover: images.length })
            //saveKey("PKCreationImages", JSON.stringify(this.state.images))
        } else {
            this.setState({ images: images });
            //this.setState({ SlideImageCover: images.length })
            //saveKey("PKCreationImages", JSON.stringify(this.state.images));
        }
    };

    customRequest = ({ uid, loaded,file, onProgress }) => {
        const onUploadProgress = () => {
            onProgress(uid, Math.round(loaded / file * 10));
        }
        onUploadProgress();
        
        return {
            abort() {
            }
        }
    }
    //   Image section ends

    componentDidMount = async function () {
        
        let new_state = {...this.state};
        
        try {
            let params = {
                sort_obj: {
                    order_integer: 'asc'
                },
                filter_obj: {
                    order_integer: {
                        gte: 1
                    }
                }
            }
            let [presentationRes,userUploadedSlidesRes] = await Promise.all([
                axios.get(`${presentation_Creation_API}/${this.state.presentation_uuid}`, myHeaders_Auth_With_Cache_Control),
                axios.get(`${presentation_Creation_API}/${this.state.presentation_uuid}/slides`, { params, ...myHeaders_Auth_With_Cache_Control }),
            ]);

            if (presentationRes.data.pptx_to_slides_start_time && !presentationRes.data.pptx_to_slides_end_time && presentationRes.data.pptx_to_slides_start_time > (get_current_unix_stamp() - 240)) {
              // pptx to slide running!
              this.setState({
                pptx_to_slides_running: '.pptx is being converted to slides...please be patient, this could take up to two minutes'
              });
              
              this.check_pptx_to_slides_interval = setInterval(() => this.checkPptxToSlidesFinish(), 3000); // 3s
              return;
            }
                
            let storedCatTempArr=[];
            let tmp_presentation_cats_obj = {};
            let cover_image_url = "";
            let slide_count = this.default_slide_count;
            let padCol = "black";
            if (presentationRes.data) {
                let resData = presentationRes.data;
                // get simple audio file name
                let audioFileName = "";
                if (resData.audio_url) {
                    let tmp_array = resData.audio_url.split('/');
                    audioFileName = tmp_array[tmp_array.length-1];
                }
                /*
                let tmp_slidesChanged = false; // trick to force video creation/recreation if there is no video URL
                if (!resData.presentation_video_url) {
                    tmp_slidesChanged = true;
                }
                */
                
                if (resData.slide_count) {
                    slide_count = resData.slide_count;
                }
                if (resData.pad_color) {
                    padCol = resData.pad_color;
                }
                new_state = {
                    ...new_state,
                    pad_color: padCol,
                    slide_count,
                    pkTitle: resData.entity_name,
                    pkFriendlyUrl: resData.friendly_url,
                    pkDescription: resData['description'],
                    //pkDescription: '',
                    PKCreationPresentationId: resData.entity_uuid,
                    pkAudio:resData.audio_url,
                    audioFileName,
                    audio_delay:resData.audio_delay,
                    language_abbreviation:resData.language_abbreviation,
                    //pad_color:resData.pad_color,
                    cover_image_url:resData.image_url,
                    slidesChanged: true,
                    //presentation_owners_array: resData.shared_access_write_uuids || []
                };
                //padCol = resData.pad_color;
                //if (padCol) {
                    //this.setState({ pad_color: padCol });
                //}
                //cover_image_url = presentationRes.data.image_url;
            }

            if(userUploadedSlidesRes.data){
                let tempUserSlidesArr=[];
                let tmp_slide_cover_index = null;
                userUploadedSlidesRes.data.forEach((item,i)=>{
                    if (i >= slide_count) {
                        //this.setState({ rugChangedCount: this.state.rugChangedCount + 1 });
                        return;
                    }
        
                    let slide_dimensions = '480x270';
                    let image_mod_string = "padblack_noborder_"+slide_dimensions;
                    let array = item.image_url.split("/");
                    if (new_state.pad_color) {
                        image_mod_string = "pad"+new_state.pad_color+"_noborder_"+slide_dimensions;
                    }
                    let modified_source = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${image_mod_string}/${array[5]}`;
                    //modified_slide_image_urls.push(`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${image_mod_string}/${array[5]}`);                   
                    
                    
                    tempUserSlidesArr.push({
                        //source: item.image_url,
                        source: modified_source,
                        name: item.entity_name,
                        xref_data:item.xref_data.order_integer,
                        entity_uuid:item.entity_uuid
                    });
                    
                    
                    if (new_state.cover_image_url && new_state.cover_image_url === item.image_url) {
                      //new_state.slide_cover_index = item.xref_data.order_integer - 1;
                      tmp_slide_cover_index = item.xref_data.order_integer - 1;
                    }
                    

                });
                if (tmp_slide_cover_index !== null) {
                  new_state.slide_cover_index = tmp_slide_cover_index;
                } else {
                  if (new_state.cover_image_url) {
                    new_state.slide_cover_index = 'custom';
                  } else {
                    new_state.slide_cover_index = 0;
                  }
                }
                
                new_state.savedImages = tempUserSlidesArr;
                //this.setState({savedImages:tempUserSlidesArr,slide_cover_index:tmp_slide_cover_index});
            }
            
            let slide_cover_array = [];
            for (let i = 0; i < slide_count; i++) {
                let slide_cover_obj = {
                  id: i,
                  text: "Slide "+(i+1),
                  value: "slide"+(i+1)
                };
                slide_cover_array.push(slide_cover_obj);
            }
            if (new_state.slide_cover_index === 'custom') {
              slide_cover_array.unshift({
                id: 'custom',
                text: "Custom",
                value: "custom"
              });
            }
            
            new_state.loading = false;
            new_state.slideCoverArr = slide_cover_array;
            
            
            this.setState( new_state );


        } catch (err) {
            // standard resolution
        }
        
        //slideCoverArr = LegacyJSON.slideCoverImage['PkCoverImg'];
    }

    handleOnChange(e) {
        this.setState({ [e.target.id]: e.target.value })
    }
    handleColorChange = (e) => {
        //this.setState({ slideBG: e.target.value }) // this should be black or white
        //console.log("handleColorChange",e);
        this.setState({ pad_color_changed: true, pad_color: e.target.value }) // this should be black or white
    }
    handleCoverSlide=(e)=>{
        //this.setState({slideCoverNum:e.target.value}); // this should be 0..19
        this.setState({ slide_cover_index_changed: true, slide_cover_index:e.target.value}); // this should be 0..19
    }
    handleOnCheck(e) {
        this.setState({ [e.target.id]: !this.state.terms })
    }

    prev = () => {
        //const { match: { params: { event_uuid } = {} } = {} } = this.props;
        this.props.history.push(`${this.workspace_base_url}${local_routes.pkcreation}/${this.state.presentation_uuid}/description`);
        //this.props.prev();
    }

    handleCancel = async () => {
        let next_page = `${this.workspace_base_url}${local_routes.pklist}`;
        if (this.props.source_info && this.props.source_info.referrer) {
            next_page = this.props.source_info.referrer;
        }
        this.props.history.push(next_page);
    }
    
    onChangePptxFile = async (event) => {
      console.log('onChangePptxFile',event.target.files);
      if (event.target.files[0]) {
        let file_name = sanitize(event.target.files[0].name).replace(/[&\s\(\)\?]/g, '_').toLowerCase();
        
        // for saving to API
        let asset_data_array_buffer_promise = new Promise(resolve => {
          let reader = new FileReader();
          reader.readAsArrayBuffer(event.target.files[0]);
          reader.onload = () => resolve(reader.result);
        });
        
        let pptx_data_array_buffer = await asset_data_array_buffer_promise;
        
        this.setState({
          pptx_to_slides_file: file_name,
          pptx_data_array_buffer
        });
      }
    }
    
    uploadPptx = async () => {
      console.log('uploadPptx');
      //return;
      this.setState({
        loading: true,
        pptx_to_slides_running: '.pptx file is being uploaded'
      });
      let params = {
        asset_type: 'raw_ppt',
        filename: this.state.pptx_to_slides_file
      };
      let asset_upload_data = await axios.post(`${apiUrl}presentations/${this.state.presentation_uuid}/getUploadSignedUrl`, {}, { params });
      //let asset_length_bytes = this.state.leaf_asset_data.byteLength;
      const config = {
        headers: { "Content-Type": asset_upload_data.data.content_type },
        //onUploadProgress: (progressEvent) => {
        //  let upload_percent = Math.floor(progressEvent.loaded / asset_length_bytes * 100);
        //  this.setState({
        //    message: 'Uploaded '+upload_percent+'%'
        //  });
        //}
      };
      let uploadUrl = asset_upload_data.data.upload_url;
      //tmp_leaf_asset_url = asset_upload_data.data.asset_url;
      await axios.put(uploadUrl, this.state.pptx_data_array_buffer, config);
      
      params = {
        preserve_ppt_overlay: true
      };
      await axios.post(`${apiUrl}presentations/${this.state.presentation_uuid}/pptxToSlides`, {}, { params });

      this.setState({
        pptx_to_slides_running: '.pptx is being converted to slides...please be patient, this could take up to two minutes'
      });
      
      this.check_pptx_to_slides_interval = setInterval(() => this.checkPptxToSlidesFinish(), 3000); // 3s
      /*
      // now kickoff new slides_zip and pptx generation
      params = {
        trigger_create_presentation_slides_zip: true,
        trigger_create_presentation_pptx: true
      }
      await axios.patch(`${apiUrl}presentations/${this.state.presentation_uuid}`, params, myHeaders_Autorized);
      */
      
      //window.location.reload();
    }
    
    componentWillUnmount() {
      clearInterval(this.check_pptx_to_slides_interval);
    }
    
    checkPptxToSlidesFinish = async () => {
      console.log("check_pptx_to_slides_interval");
      let params = {
        attributes: ['pptx_to_slides_start_time','pptx_to_slides_end_time']
      }
      let results = await axios.get(`${apiUrl}presentations/${this.state.presentation_uuid}`, { params, ...myHeaders_Auth_With_Cache_Control });
      if (!results.data.pptx_to_slides_start_time || (results.data.pptx_to_slides_start_time < (get_current_unix_stamp() - 240)) || (results.data.pptx_to_slides_start_time && results.data.pptx_to_slides_end_time)) {
        clearInterval(this.check_pptx_to_slides_interval);
        window.location.reload();
      }
    }
    

    render() {
        const { allowed,descriptionLoader,ImgPublishBtn,ImageUploadLoader, pkTitleCollision, imageValidator, savedImages } = this.state;
        
        let pro_features_enabled = false;
        if (this.workspace_base_url || user_account_level === 'private' || user_access_level === 'admin' || (this.context.user_info.events && this.context.user_info.events.length > 0)) {
            pro_features_enabled = true;
        }
        //console.log("RENDER",this.state.pad_color);

        if (this.state.loading === true) {
            return (
              <React.Fragment>
              { this.state.pptx_to_slides_running &&
                <span style={{ color: 'green'}}><center>{this.state.pptx_to_slides_running}</center></span>
              }
                <ActivityIndicator theme="spinner" />
              </React.Fragment>
            )
        }

        return (
            <div>

                          <Container style={{ marginTop: "0px", marginBottom: "10px" }}>
                            { pro_features_enabled ?
                              <Row className="justify-content-center">
                                <Col xs={5} md={5} style={{ fontSize: "smaller" }}>
                                    Add or Replace Slide Images with Images from a PowerPoint (.pptx) File
                                </Col>
                                <Col xs={5} md={5}>
                                  <Form.Group>
                                      <Form.File
                                        id={"pptx-to-slides-upload"}
                                        custom={true}
                                        disabled={ImageUploadLoader}
                                      >
                                      
                                        <Form.File.Input
                                          title={this.state.pptx_to_slides_file || 'Click to Upload .pptx File'} // this handles the mouseover tooltip better
                                          //disabled={!this.state.editing || this.state.loading}
                                          onChange={this.onChangePptxFile}
                                          //isInvalid={this.state.validated && !this.state.pptx_to_slides_file}
                                          accept={'application/vnd.openxmlformats-officedocument.presentationml.presentation'}
                                          //ref={this.uploadPptxFileRef}
                                        />
                                        <Form.File.Label>{this.state.pptx_to_slides_file || 'Click to Upload .pptx File'}</Form.File.Label>
                                        <Form.Control.Feedback type="invalid">.pptx file is required</Form.Control.Feedback>
                                      </Form.File>
                                    
                                  </Form.Group>
                                </Col>
                                <Col xs={2}>
                                  { (this.state.pptx_data_array_buffer && this.state.pptx_to_slides_file) &&
                                    <Button
                                      size="sm"
                                      style={{ marginTop: "-10px" }}
                                      variant="pkprimary"
                                      onClick={this.uploadPptx}
                                    >
                                      Replace with .pptx Data
                                    </Button>
                                  }
                                </Col>

                              </Row>
                              :
                              <Row className="justify-content-center">
                                <Col xs={2}>
                                </Col>
                                <Col xs={8}>
                                  {ImageUploadLoader ?
                                    <span>
                                      Add or Replace Slide Images with Slides from a PowerPoint (.pptx) File <span style={{ color: "green" }}> *Requires PK Create PRO*</span>
                                    </span>
                                  :
                                    <Link
                                      to={local_routes.pricing}
                                      style={{ color: this.context.theme === "dark" ? "#eeeeee" : "#222222" }}
                                    >
                                      Add or Replace Slide Images with Slides from a PowerPoint (.pptx) File <span style={{ color: "green" }}> *Requires PK Create PRO*</span>
                                    </Link>
                                  }
                                </Col>
                                <Col xs={2}>
                                </Col>
                              </Row>                                
                            }

                          </Container>                    


                <div className="Upload form-card">

                    <div style={{ }} className="Upload-header">

                    {
                        imageValidator === true ?
                            <div style={{ marginTop: "0px", textAlign: "center" }} className="PKTitleCollision">Please add exactly {this.state.slide_count} image(s) to continue</div>
                            :
                            null
                    }
                    { this.state.slide_problem_message &&
                        <p style={{ marginTop: "0px", textAlign: "center" }} className="PKTitleCollision">{this.state.slide_problem_message}</p>
                    }
                    {ImageUploadLoader === true ?
                            <p style={{ marginTop: "0px", textAlign: "center" }} className="PKTitleSuccess">Uploading Slides</p>
                            :
                            null
                    }
                    { this.state.slide_upload_progress_message &&
                        <p style={{ textAlign: "center" }} className="PKTitleSuccess">{this.state.slide_upload_progress_message}</p>
                    }

                        <img src={logo} className="Upload-logo" alt="logo"/>
                        <h3>Drag and Drop to upload {this.state.slide_count} image(s)</h3>
                        <span className="btn browse">
                          or <span className="file-browse">browse</span> to choose a file
                        </span>



                        <div className="type-image">
                            <h3>
                                Please upload horizontal .jpg, .png, or .gif files under 3000x1300 pixels.<br/>
                                Recommended image ratio is 16:9 (example: 1280 x 780 pixels)
                            </h3>
                        </div>
                    </div>

                    
                        <div className="tab-data">
                            <div className="slides uploadSlides">
                                <div className="slide-upload">
                                    <h4>Slides</h4>
                                    <p style={{ fontSize: "smaller"}}>
                                      Please click and hold the image to drag and re-order slides.<br/>
                                      If on a touch-screen device, please double-click to drag and re-order slides.<br/>
                                      Slides are ordered per-row, left-to-right.<br/>
                                    </p>
                                </div>
                                <div className="uploadDropdown">
                                    <Form>
                                        <Form.Group>
                                            <div className="form-dropdownlist">
                                                <Form.Label>Cover Image</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    required
                                                    value={this.state.slide_cover_index}
                                                    onChange={this.handleCoverSlide}
                                                >
                                                    {
                                                        this.state.slideCoverArr.map((item)=>
                                                        (
                                                            <option key={item.id} value={item.id}>{item.text}</option>
                                                        ))
                                                    }
                                                </Form.Control>
                                            </div>
                                        </Form.Group>
                                    </Form>
                                
                                    <Form>
                                        <Form.Group>
                                            <div className="form-dropdownlist">
                                                <Form.Label>Background</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    required
                                                    // id="eventdropdown"
                                                    // value={this.props.eventdropdown}
                                                    value={this.state.pad_color}
                                                    onChange={this.handleColorChange}
                                                >
                                                    <option value="black">Black</option>
                                                    <option value="white">White</option>
                                                </Form.Control>
                                            </div>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </div>
                        
                        <RUG
                          className={`${this.state.pad_color}-rug-card`}
                          initialState={savedImages}
                          // rules={{ limit: {this.number_of_slides} }}
                          accept={['jpg', 'jpeg', 'png', 'gif']}
                          // action="/api/upload" // upload route
                          source={response => response.source}
                          onChange={this.onChangeImages}
                          customRequest={this.customRequest}
                          //onClick={() => console.log("CLICKED")}
                        />

                    <div className="form-group btn-position btn-text">
                        
                        {/* <button className="btn btn-draft">Save Draft</button> */}
                        <div className="spinner-section">
                            {ImageUploadLoader === false ? (
                                <div>
                                <button className="btn btn-draft" onClick={() => this.prev()}>Previous</button>
                                <button className="btn btn-draft" onClick={() => this.handleCancel()}>Cancel</button>
                                <button className="btn btn-next" onClick={this.createPk}>Save + Next</button>
                                    {/*
                                    { ImgPublishBtn === false  ?  "Next" :  "Next" }
                                    */}
                                </div>
                            ) : (
                                <ActivityIndicator theme="button-Status-Loader" />
                            )}
                        </div>
                    </div>
                    {/*
                    <div className="form-group d-flex justify-content-start createpkUploadBtn btn-text">
                        
                        <div className="spinner-section">
                            {ImageUploadLoader === false ? (
                                <div>
                                <button className="btn btn-draft" onClick={() => this.prev()}>Previous</button>
                                <button className="btn btn-next"
                                    onClick={this.createPk}>
                                    { ImgPublishBtn === false  ?  "Next" :  "Next" }
                                    </button>
                                </div>
                            ) : (
                                <ActivityIndicator theme="button-Status-Loader" />
                            )}
                        </div>
                    </div>
                    */}
                </div>
            </div>
        );
    }
}

export default withRouter(PresentationSlides);
